module.exports = __webpack_public_path__ + "static/img/幀互動.ba01ce51.svg";